/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_Media1Inputs */

const id_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const ms_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const da_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medier`)
};

const de_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien`)
};

const en_us2_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const es_es2_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios`)
};

const es_mx2_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multimedia`)
};

const fil_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const fr_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médias`)
};

const it_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const hu_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média`)
};

const nl_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const no_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const pl_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multimedia`)
};

const pt_br2_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia`)
};

const pt_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multimédia`)
};

const ro_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const fi_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const sv_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const vi_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương tiện`)
};

const tr_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medya`)
};

const cs_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média`)
};

const bg_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медия`)
};

const ru_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиа`)
};

const uk_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медіа`)
};

const ar_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوسائط`)
};

const hi_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया`)
};

const th_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สื่อ`)
};

const ja_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア`)
};

const zh_cn2_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体`)
};

const zh_hant1_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒體`)
};

const ko_offerdetail_notifications_media1 = /** @type {(inputs: Offerdetail_Notifications_Media1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미디어`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {Offerdetail_Notifications_Media1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_media1 = /** @type {((inputs?: Offerdetail_Notifications_Media1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_Media1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_media1(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_media1(inputs)
	if (locale === "da") return da_offerdetail_notifications_media1(inputs)
	if (locale === "de") return de_offerdetail_notifications_media1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_media1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_media1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_media1(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_media1(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_media1(inputs)
	if (locale === "it") return it_offerdetail_notifications_media1(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_media1(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_media1(inputs)
	if (locale === "no") return no_offerdetail_notifications_media1(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_media1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_media1(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_media1(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_media1(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_media1(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_media1(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_media1(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_media1(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_media1(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_media1(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_media1(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_media1(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_media1(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_media1(inputs)
	if (locale === "th") return th_offerdetail_notifications_media1(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_media1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_media1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_media1(inputs)
	return ko_offerdetail_notifications_media1(inputs)
});
export { offerdetail_notifications_media1 as "offerDetail.notifications.media" }